// // js-accordion
 (function() {

 	function Accordion(container) {
		this.container = container;
		this.init();
	}

	Accordion.prototype = {
		init: function(){
			this.issubmenu();
			this.click();
		},
		issubmenu: function(){
			$(this.container).find("[data-accordion-item]").each(function(){
				if ($(this).find("[data-accordion-content]").length != "0"){
					$(this).find("[data-accordion-link]").addClass("has-submenu");
				}
			})
		},
		click: function (){
			var $container = $(this.container);

			$container.find("[data-accordion-link]").on("click",function(e){

				var _this = $(this),
					itemAccordion = _this.closest("[data-accordion-item]"),
					contentAccordion = itemAccordion.find("[data-accordion-content]");
				
				if ((contentAccordion.length != "0") && 
					(!$(e.target).closest('[data-accordion-content]').length)) {

			 		if (!itemAccordion.hasClass("is-open")){
			 			e.preventDefault();
			 			
			 			var currContainer = _this.closest("[data-accordion]");
			 			if(currContainer.data('accordion') == 'toggle'){
			 				currContainer.find("[data-accordion-content]").slideUp();
			 				currContainer.find("[data-accordion-item]").removeClass("is-open");
			 			}
			 			
			 			contentAccordion.slideDown();
			 			itemAccordion.addClass("is-open");
			 		} else {
			 			e.preventDefault();
			 			contentAccordion.slideUp();
			 			itemAccordion.removeClass("is-open"); 
			 		}	

		 		}
		 	})
		}
	}
 	var accord = new Accordion($("[data-accordion]"));

 })();



// WEBPACK FOOTER //
// ./components/js-accordion.js